import { ActionTree } from 'vuex'

import { RecommendState, RootState } from '@/types/store'
import { getRecommends } from '@/api/recommend'

export const actions: ActionTree<RecommendState, RootState> = {
  async getRecommends(
    { commit },
    { query, categoryId }: { query: string; categoryId: number },
  ): Promise<void> {
    commit('recommendsLoaded', [])
    commit('recommendsLoadStart', true)
    const recommends = await getRecommends(query, categoryId)
    commit('recommendsLoaded', recommends)
  },
  reset({ commit }): void {
    commit('recommendsLoaded', [])
  },
}
